import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatPrice } from "@/lib/format";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get("/admin/orders").then((r) => setOrders(r.data || [])).catch(() => {});
  }, []);
  const StatusPill = ({ status }) => (
    <span className={`inline-block px-2 py-1 rounded-full text-[11px] whitespace-nowrap ${status === "paid" ? "bg-green-50 text-green-700 border border-green-200" : "bg-neutral-100 text-neutral-700"}`}>
      {status}
    </span>
  );

  return (
    <div className="p-5 sm:p-8 lg:p-12" data-testid="admin-orders-page">
      <div className="text-xs uppercase tracking-widest text-neutral-500">Orders</div>
      <h1 className="editorial font-serif-display text-3xl sm:text-4xl mt-2">All orders</h1>

      {orders.length === 0 ? (
        <div className="mt-8 border border-dashed border-black/15 rounded-sm px-5 py-16 text-center text-neutral-500 text-sm bg-white" data-testid="no-orders">
          No orders yet.
        </div>
      ) : (
        <>
          {/* Mobile / small screens: stacked cards */}
          <div className="mt-8 space-y-3 md:hidden">
            {orders.map((o) => (
              <article key={o.order_id} className="bg-white border border-black/10 rounded-sm p-4" data-testid={`order-row-${o.order_id}`}>
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="text-[11px] uppercase tracking-widest text-neutral-500">Order</div>
                    <div className="text-sm font-mono break-all">{o.order_id}</div>
                  </div>
                  <StatusPill status={o.payment_status} />
                </div>
                <div className="mt-3 text-sm text-neutral-800 break-all" title={o.email}>{o.email}</div>
                <div className="mt-3 flex items-center justify-between text-sm">
                  <div className="text-neutral-500 text-xs">{new Date(o.created_at).toLocaleDateString()}</div>
                  <div className="font-medium">{formatPrice((o.amount_total || 0) / 100, o.currency)}</div>
                </div>
              </article>
            ))}
          </div>

          {/* Desktop / md+: table (unchanged visual) */}
          <div className="mt-10 border border-black/10 bg-white rounded-sm overflow-hidden hidden md:block">
            <div className="grid grid-cols-12 px-5 py-3 text-xs uppercase tracking-widest text-neutral-500 border-b border-black/5">
              <div className="col-span-3">Order</div>
              <div className="col-span-3">Email</div>
              <div className="col-span-2">Status</div>
              <div className="col-span-2">Total</div>
              <div className="col-span-2 text-right">Date</div>
            </div>
            {orders.map((o) => (
              <div key={o.order_id} className="grid grid-cols-12 items-center px-5 py-4 border-b border-black/5 last:border-b-0" data-testid={`order-row-desktop-${o.order_id}`}>
                <div className="col-span-3 text-sm font-mono truncate">{o.order_id}</div>
                <div className="col-span-3 text-sm text-neutral-700 truncate">{o.email}</div>
                <div className="col-span-2"><StatusPill status={o.payment_status} /></div>
                <div className="col-span-2 text-sm">{formatPrice((o.amount_total || 0) / 100, o.currency)}</div>
                <div className="col-span-2 text-right text-xs text-neutral-500">{new Date(o.created_at).toLocaleDateString()}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
